__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "uk_borrower_platform_billing_and_payments";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@honeybadger-io/js", "6.11.1", () => (__webpack_require__.e(807).then(() => (() => (__webpack_require__(9807))))));
			register("classnames", "2.5.1", () => (__webpack_require__.e(139).then(() => (() => (__webpack_require__(8139))))));
			register("flexipay-pay-form", "3.0.15", () => (Promise.all([__webpack_require__.e(412), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(5412))))));
			register("moment", "2.30.1", () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(6178))))));
			register("operation-diameter", "5.1.27", () => (Promise.all([__webpack_require__.e(469), __webpack_require__.e(914), __webpack_require__.e(651)]).then(() => (() => (__webpack_require__(2469))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-router-dom", "6.30.1", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(3245))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			initExternal(2791);
			initExternal(9801);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};